// extracted by mini-css-extract-plugin
export default {"layout":"style-layout-1WDve","contentLayout":"style-contentLayout-3PPPt","content":"style-content-3okVp"};